import React from 'react';
import classNames from 'classnames';

export default function CardFooter(props: { children?: React.ReactNode; className?: string }) {
  return (
    <div
      className={classNames(
        'px-2 py-3 flex justify-center space-x-2',
        'md:px-4 md:space-x-4 md:py-5 sm:px-6',
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
